import {animationOptions} from './animate-on-scroll'
// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'

let avatarSwapInterval: number | undefined
let avatarSwapTimeout: number | undefined
let avatarSwapSetupInterval: number | undefined
let avatarStacks: NodeListOf<HTMLElement>
let currentAvatarSwapElement: Element | null = null
const AVATAR_SWAP_SETUP_DELAY = 250
const AVATAR_SWAP_DELAY = 3000

function avatarSwap(stack: HTMLElement) {
  if (!stack) {
    return
  }

  const avatars: NodeListOf<HTMLElement> = stack.querySelectorAll('img')
  const currentAvatar: NodeListOf<HTMLElement> = stack.querySelectorAll('img.diversity-current-avatar')

  if (!avatars.length) {
    return
  }

  if (!currentAvatar.length) {
    avatars[0]!.classList.add('diversity-current-avatar')
    return
  }

  if (avatars.length < 2) {
    return
  }

  for (let i = 0; i < avatars.length; i++) {
    const element = avatars[i]!

    if (element.matches('.diversity-current-avatar')) {
      element.classList.remove('diversity-current-avatar')

      let currentAvatarIndex = i + 1
      currentAvatarIndex = currentAvatarIndex >= avatars.length ? 0 : currentAvatarIndex
      avatars[currentAvatarIndex]!.classList.add('diversity-current-avatar')

      break
    }
  }
}

function avatarSwapClear(stacks: NodeListOf<HTMLElement>) {
  window.clearInterval(avatarSwapInterval)
  window.clearInterval(avatarSwapSetupInterval)
  window.clearTimeout(avatarSwapTimeout)

  if (!stacks || !stacks.length) {
    return
  }

  for (let i = 0; i < stacks.length; i++) {
    const element = stacks[i]!
    const avatar: HTMLElement | null = element.querySelector('img.diversity-current-avatar')

    if (avatar) {
      avatar.classList.remove('diversity-current-avatar')
    }
  }
}

function avatarSwapSetup(element: Element) {
  const setupDelay = Number(element.getAttribute('data-avatar-swap-setup-delay') || AVATAR_SWAP_SETUP_DELAY)
  const delay = Number(element.getAttribute('data-avatar-swap-delay') || AVATAR_SWAP_DELAY)

  avatarStacks = element.querySelectorAll('.diversity-avatar-stack')

  if (!avatarStacks || !avatarStacks.length) {
    return
  }

  let currentStack = 0

  avatarSwapSetupInterval = window.setInterval(() => {
    avatarSwap(avatarStacks[currentStack]!)
    currentStack = currentStack + 1

    if (currentStack >= avatarStacks.length) {
      window.clearInterval(avatarSwapSetupInterval)
      currentStack = 0

      avatarSwapInterval = window.setInterval(() => {
        avatarSwap(avatarStacks[currentStack]!)
        currentStack = currentStack + 1
        currentStack = currentStack >= avatarStacks.length ? 0 : currentStack
      }, delay)
    }
  }, setupDelay)
}

function avatarSwapObserverCallback(entries: IntersectionObserverEntry[]) {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      currentAvatarSwapElement = entry.target
      avatarSwapSetup(entry.target)
    } else {
      if (avatarStacks && currentAvatarSwapElement && currentAvatarSwapElement.isEqualNode(entry.target)) {
        avatarSwapClear(avatarStacks)
      }
    }
  }
}

//TODO: should use singular IntersectionObserver instace also should create spearate scope for each element
observe('.js-diversity-avatar-stacks', element => {
  const options = animationOptions(element)
  const customObserver = new IntersectionObserver(avatarSwapObserverCallback, {
    rootMargin: `-${options.marginTop}% 0% -${options.marginBottom}% 0%`,
    threshold: options.threshold,
  })
  customObserver.observe(element)
})
